module.exports = __webpack_public_path__ + "a7e363f8ecdeb29fe1d412f7a20e4ed4.svg";